import script from "./ScreenMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./ScreenMessage.vue?vue&type=script&setup=true&lang=js"

import "./ScreenMessage.vue?vue&type=style&index=0&id=18e7c4e5&scoped=true&lang=css"

import exportComponent from "/Users/tannerwelton/Development/zulu-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18e7c4e5"]])

export default __exports__